/**
 * Shorthand for console.log
 *
 * @param {object|string} message The message to log.
 */
export default function(message) {
  console.log(message);
}

